import React, { useContext, useEffect, useRef, useState } from "react";
import { FormioProvider } from "../../context/FormioContext";
// import { Form } from "../../OurForms/Form";
import { useLocation } from "react-router-dom";
import { BreadcrumbsContext } from "../../context/BcrumbsContextProvider";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { NewForm } from "../../OurForms/NewForm";
import { useSelector } from "react-redux";
import { fetchEquipmentApi } from "../../Apis/Inspection/InspectionApis";
function MyInspectionForm() {
  const location = useLocation();
  const formInstance = useRef(null);
  const querydata = location.state?.data;
  const submission = location.state?.submission;
  console.log("this is submission", querydata);
  const { UserRolesData } = useSelector((state) => state?.Roles);
  const navigate = useNavigate();
  const [disableCompponents, setdisableCompponents] = useState(null);
  const { setBreadcrumbsItems } = useContext(BreadcrumbsContext);
  const handleBreadcrumbs = () => {
    setBreadcrumbsItems([
      {
        id: 1,
        url: "/my-package/pending",
        name: "My Packages",
      },
      {
        id: 2,
        url: "/my-package/form",
        name: "Form",
      },
    ]);
  };
  const toCamelCase = (str) => {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase()
      )
      .replace(/\s+/g, "");
  };

  // const handleEquipmentChange = async ({ changed, data }, modified, formInstance) => {
  //   console.log("data", data);

  //   if (changed?.component?.key === "equipmentNumber" && modified) {
  //     const response = await fetchEquipmentApi(
  //       data.equipmentNumber,
  //       querydata.jobSiteId
  //     );

  //     // ✅ keep submit button enabled
  //     formInstance.current.options = {
  //       ...formInstance.current.options,
  //       alwaysDirty: true,
  //     };

  //     console.log(response, querydata, data.equipmentNumber);

  //     if (response?.data) {
  //       const equipmentData = response?.data?.equipmentWorking[0] || {};

  //       // ✅ only keep keys that already exist in the form submission
  //       const existingKeys = Object.keys(formInstance.current.submission.data);
  //       const filteredData = Object.fromEntries(
  //         Object.entries(equipmentData).filter(([key]) =>
  //           existingKeys.includes(key)
  //         )
  //       );

  //       formInstance.current.setSubmission(
  //         {
  //           ...formInstance.current.submission,
  //           data: {
  //             ...formInstance.current.submission.data,
  //             ...filteredData,
  //             submit: true
  //           },
  //         },
  //         { noValidate: true, modified: true }
  //       );
  //     }
  //   }
  // };

  const handleEquipmentChange = async ({ changed, data }, modified, formInstance) => {
    console.log(modified);
    if (changed?.component?.key === "equipmentNumber" && data.equipmentNumber === querydata?.equipmentNumbers
    ) {
      const response = await fetchEquipmentApi(
        data.equipmentNumber,
        querydata.jobSiteId
      );

      if (response?.data) {
        const equipmentData =
          response?.data?.equipmentWorking?.length > 0
            ? response?.data?.equipmentWorking?.[0]
            : response?.data?.componentWorking?.[0];

        const componentData = response?.data?.componentWorking || [];
        const existingKeys = Object.keys(formInstance.current.submission.data);

        const filteredData = Object.fromEntries(
          Object.entries(equipmentData).filter(([key]) =>
            existingKeys.includes(key)
          )
        );

        // Start building new form data
        let newFormData = {
          ...formInstance.current.submission.data,
          ...filteredData,
        };

        let nozzleComponents = [];

        // 🔹 Loop through componentWorking
        componentData.forEach((comp) => {
          const concat = comp?.concatenate?.toUpperCase() || "";
          const compMaster = comp?.compMaster?.toUpperCase() || "";

          if ((concat.includes("NOZ") || compMaster.includes("NOZZLE")) && querydata?.form?.title === "NDC") {
            nozzleComponents.push(comp);
            newFormData = {
              ...newFormData,
              nozzle1: nozzleComponents,
            };
          }

          if (concat.includes("TOP SHELL")) {
            newFormData = {
              ...newFormData,
              vesselIdIn: comp.innerDiameter,
              internalPressurePsi: comp.codeSignPressure,
              internalTempF: comp.codeSignTemperature,
              externalPressurePsi: comp.orgCorAllow,
              externalTempF: comp.codeSignTemperature,
              mdmtPerNameplateOrU1A: comp.mdmTemperature,
            };
          }

          if (concat.includes("BOTTOM SHELL")) {
            newFormData = {
              ...newFormData,
              vesselIdIn1: comp.innerDiameter,
              internalPressurePsi1: comp.codeSignPressure,
              internalTempF1: comp.codeSignTemperature,
              externalPressurePsi1: comp.orgCorAllow,
              externalTempF1: comp.codeSignTemperature,
              mdmtPerNameplateOrU1A1: comp.mdmTemperature,
            };
          }

          if (concat.includes("TOP HEAD")) {
            newFormData = {
              ...newFormData,
              hemi21TorrFlat: comp.headGeom,
              material1: comp.refMaterial,
              efficiencyOrRtMark1: comp.jointEfficiency,
              nominalThicknessIn1: comp.orgThickness,
              minMeasuredThicknessIn1: comp.orgThickness,
            };
          }

          if (concat.includes("BOTTOM HEAD")) {
            newFormData = {
              ...newFormData,
              hemi21TorrFlat1: comp.headGeom,
              material2: comp.refMaterial,
              efficiencyOrRtMark2: comp.jointEfficiency,
              nominalThicknessIn2: comp.orgThickness,
              minMeasuredThicknessIn2: comp.orgThickness,
            };
          }

          if (concat.includes("-SHELL")) {
            newFormData = {
              ...newFormData,
              pwht: comp.pwht,
              refMaterial: comp.refMaterial,
              jointEfficiency: comp.jointEfficiency,
              orgThickness: comp.orgThickness,
            };
          }
        });

        newFormData = {
          ...newFormData,
          ...querydata?.previousFormSubmission?.data,
        };
        formInstance.current.setSubmission(
          {
            ...formInstance.current.submission,
            data: newFormData,
          },
          { noValidate: true, modified: false }
        );
      }
    }
  };

  useEffect(() => {
    if (UserRolesData) {
      // Define the roles that you want to check
      console.log(UserRolesData, "Yes");

      const roleKeys = [
        "qcInspector",
        "processEngineer",
        "operationalManager",
        "executiveJobSupervisor",
        "qaInspector",
      ];
      const roleArr = UserRolesData?.role?.map((role) => {
        let camelRole = toCamelCase(role.roleName);

        // Handle special case for qCInspector
        if (camelRole === "qCInspector") {
          camelRole = "qcInspector";
        } else if (camelRole === "qAInspector") {
          camelRole = "qaInspector";
        } else if (camelRole === "executive/JobSupervisor") {
          camelRole = "executiveJobSupervisor";
        }

        return camelRole;
      });

      let obj = {};

      // Create the object with key-value pairs only for matching roles
      roleKeys.forEach((key) => {

        if (!roleArr?.includes(key)) {
          obj[key] = true;
          obj[`${key}1`] = true;
          obj[`${key}2`] = true;
          obj[`${key}3`] = true;
          obj[`${key}4`] = true;
          obj[`${key}5`] = true;
          obj[`${key}6`] = true;
          obj[`${key}7`] = true;
          obj[`${key}8`] = true;
          obj[`${key}9`] = true;
        }
      });

      if (Object.keys(obj).length === 0) {
        setdisableCompponents(null); // Set null if obj is empty
      } else {
        setdisableCompponents({
          ...obj,
        }); // Set the object if it contains any key-value pairs
      }
    }
  }, [UserRolesData]);

  useEffect(() => {
    handleBreadcrumbs();
    return () => {
      setBreadcrumbsItems([]);
    };
  }, [setBreadcrumbsItems]);
  const prefillFormFields = (form) => {
    console.log("this is form", form);
    if ((form?._form?.title === "SSDC" || form?._form?.title === "VCDCC" || form?._form?.title === "VCDC-ND" || form?._form?.title === "NDC") && querydata?.previousFormSubmission) {
      console.log("come inner");
      const refillData = querydata?.previousFormSubmission?.data;
      const facility = form.getComponent("facility");
      if (facility) {
        facility.setValue(refillData?.facility, { fromSubmission: true });
      }

      const unit = form.getComponent("unitNumber");
      if (unit) {
        unit.setValue(refillData?.unitNumber, { fromSubmission: true });
      }

      const serialNumber = form.getComponent("serialNumber");
      if (serialNumber) {
        serialNumber.setValue(refillData?.serialNumber, { fromSubmission: true });
      }


      const service = form.getComponent("description");
      if (service) {
        service.setValue(refillData?.description, { fromSubmission: true });
      }
      const nationalBoard = form.getComponent("regNumber");
      if (nationalBoard) {
        nationalBoard.setValue(refillData?.regNumber, { fromSubmission: true });
      }
      const qrCnic = form.getComponent("equipmentNumber");
      if (qrCnic) {
        qrCnic.setValue(refillData?.equipmentNumber, { fromSubmission: true });
      }
    }
  };
  return (
    <div style={{ height: "100vh", overflowY: "scroll" }}>
      <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            color: "black",
            cursor: "pointer",
            marginRight: "16px",
            marginBottom: "7px",
          }}
        >
          <IoMdArrowBack fontSize="24px" />
        </button>
        <h1 style={{ fontSize: "24px", fontWeight: "bold" }}>
          {querydata?.form?.title}
        </h1>
        {/* Back button */}
      </div>
      <p>Form ID: {querydata?.form?._id}</p>
      <FormioProvider baseUrl={process.env.REACT_APP_API_URL_LOCAL}>
        {submission &&
          querydata?.mySubmissionStatus == "Submitted" &&
          disableCompponents ? (
          <NewForm
            formInstance={formInstance}
            title={querydata?.form?.name}
            src={`Forms/${querydata?.form?._id}`}
            submission={submission}
            inspectionStageId={querydata?.currentStage}
            submissionId={querydata?.submissionId}
            options={{
              readOnly: true,
              hideSumbit: true,

              hide: {
                submit: true,
              },
              disabled: {
                ...disableCompponents,
              },
            }}
          />
        ) : submission ? (
          disableCompponents && (
            <NewForm
              src={`Forms/${querydata?.form?._id}`}
              submission={submission}
              formInstance={formInstance}
              onChange={({ changed, data }, flags, modified) => {
                console.log(data, modified, changed, flags);
                handleEquipmentChange(
                  { changed, data },
                  modified,
                  formInstance
                );
              }}
              options={{
                disabled: {
                  ...disableCompponents,
                },
              }}
              inspectionStageId={querydata?.currentStage}
              submissionId={querydata?.submissionId}

            />
          )
        ) : (
          disableCompponents && (
            <NewForm
              src={`Forms/${querydata?.form?._id}`}
              formInstance={formInstance}
              inspectionStageId={querydata?.currentStage}
              options={{
                disabled: {
                  ...disableCompponents,
                },
              }}
              onChange={({ changed, data }, flags, modified) => {
                console.log(data, modified, changed, flags);
                handleEquipmentChange(
                  { changed, data },
                  modified,
                  formInstance,
                );
              }}
              onFormReady={(form) => {
                prefillFormFields(form);

              }}
            />
          )
        )}
      </FormioProvider>
    </div>
  );
}

export default MyInspectionForm;
